import { get } from 'lodash';
import { PROGRESS_START, PROGRESS_END } from './demoVideoConstants';

export const isPreviousVideoWatched = (demoVideosProgress, prevId) => get(demoVideosProgress, `${prevId}.watched`, false);

export const shouldPlayNextVideo = (paused, demoVideosProgress, activeVideoId) => {
    const isDone = get(demoVideosProgress, `${activeVideoId}.progress`, PROGRESS_START) === PROGRESS_END;
    return isDone && paused;
};

export const getTotalTimeElapsed = videos => {
    let totalTime = 0;
    videos.forEach(video => {
        totalTime += get(video, 'currentTime', 0);
    });
    return totalTime;
};

export const formatSecondsIntoTimestamp = secs => {
    const minutes = Math.floor(secs / 60);
    const seconds = Math.floor(secs % 60);
    return `${minutes}:${seconds > 9 ? seconds : `0${seconds}`}`;
};

export const getFormattedCurrentTime = (videos) => {
    const currentTime = getTotalTimeElapsed(videos);
    return formatSecondsIntoTimestamp(currentTime);
};
